(function () {
  'use strict';

  var FIELDS = 'title,product_type,variants.title,vendor';
  var TYPES = 'product,query,collection';
  var scheduled = false;

  function ensureHiddenBeforeQuery(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      var query = form.querySelector('[name="q"]');
      if (query && query.parentNode) query.parentNode.insertBefore(input, query);
      else form.insertBefore(input, form.firstChild);
    }
    input.value = value;
  }

  function disableLegacyProductTypeScope(form) {
    var select = form.querySelector('select[name="product_type"]');
    if (!select) return;
    select.value = '*';
    select.disabled = true;
    var wrapper = select.closest('.hdt-search__categories');
    if (wrapper) {
      wrapper.hidden = true;
      wrapper.style.display = 'none';
    }
    form.classList.remove('hdt-search-has_cat-true');
    form.classList.add('hdt-search-has_cat-false');
  }

  function optimizePredictiveForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[is="predictive-search"]').forEach(function (form) {
      disableLegacyProductTypeScope(form);
      var fields = form.querySelector('input[name="resources[options][fields]"]');
      if (fields) fields.value = FIELDS;
      else ensureHiddenBeforeQuery(form, 'resources[options][fields]', FIELDS);
      ensureHiddenBeforeQuery(form, 'resources[type]', TYPES);
    });
  }

  function prioritizeProducts(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.hdt-search-products').forEach(function (products) {
      var parent = products.parentElement;
      if (!parent) return;
      var queries = parent.querySelector(':scope > .hdt-search-queries');
      if (queries) parent.insertBefore(products, queries);
    });
  }

  function replaceCountText(heading, previousCount, nextCount) {
    var walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (parent && (parent.tagName === 'STYLE' || parent.tagName === 'SCRIPT')) continue;
      var value = node.nodeValue || '';
      var index = value.indexOf(previousCount);
      if (index !== -1) {
        node.nodeValue = value.slice(0, index) + nextCount + value.slice(index + previousCount.length);
        return true;
      }
    }
    return false;
  }

  function syncSearchHeadingCount() {
    if (window.location.pathname.indexOf('/search') === -1) return;
    var heading = document.querySelector('.hdt-main-heading .hdt-heading-liquid');
    var source = document.querySelector('[data-sicilus-results-count]');
    if (!heading || !source) return;

    var nextCount = source.getAttribute('data-sicilus-results-count');
    if (nextCount === null || nextCount === '') return;

    var previousCount = heading.getAttribute('data-sicilus-search-count');
    if (!previousCount) {
      heading.setAttribute('data-sicilus-search-count', nextCount);
      return;
    }
    if (previousCount === nextCount) return;

    if (replaceCountText(heading, previousCount, nextCount)) {
      heading.setAttribute('data-sicilus-search-count', nextCount);
    }
  }

  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      optimizePredictiveForms(root || document);
      prioritizeProducts(root || document);
      syncSearchHeadingCount();
    }, 0);
  }

  function start() {
    optimizePredictiveForms(document);
    prioritizeProducts(document);
    syncSearchHeadingCount();

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i += 1) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            schedule(mutations[i].target);
            break;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('products:update', function () { schedule(document); });
  document.addEventListener('shopify:section:load', function (event) { schedule(event.target); });
  window.addEventListener('popstate', function () { schedule(document); });
})();
